import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/SaleStatus";

export const GetAll = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const Update = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const UpdateOrders = (options) =>
  GENERATE_URL(`${PREFIX_URL}/UpdateOrders`, options);

export default {
  GetAll,
  Update,
  UpdateOrders,
};
